const radTwoRouter = [
  {
    path: '/radTwo',
    name: 'radTwo',
    component: () => import('@/views/wxapp/rad/radTwo/'),
    meta: {
      title: '空间功能需求评估'
    },
    children: [
      {
        path: 'radTwoCover',
        name: 'radTwoCover',
        component: () => import('@/views/wxapp/rad/radTwo/radTwoCover'),
        meta: {
          title: '空间功能需求评估'
        }
      },
      {
        path: 'describePage',
        name: 'describePage',
        component: () => import('@/views/wxapp/rad/radTwo/describePage'),
        meta: {
          title: '空间功能需求评估'
        }
      },
      {
        path: 'spacePage',
        name: 'spacePage',
        component: () => import('@/views/wxapp/rad/radTwo/spacePage'),
        meta: {
          title: '空间功能需求评估'
        }
      },
      {
        path: 'spaceDetails',
        name: 'spaceDetails',
        component: () => import('@/views/wxapp/rad/radTwo/spaceDetails'),
        meta: {
          title: '空间功能需求评估'
        }
      },
      {
        path: 'spaceList',
        name: 'spaceList',
        component: () => import('@/views/wxapp/rad/radTwo/spaceList'),
        meta: {
          title: '空间功能需求评估'
        }
      },
      {
        path: '/rad2-InvitationLook',
        name: 'InvitationLook',
        component: () => import('@/views/wxapp/customer-manager/measuringRoom/InvitationLook'),
        meta: {
          title: '勘测邀请函'
        }
      },
      {
        path: '/rad2-surveyInvitation',
        name: 'surveyInvitation',
        component: () => import('@/views/wxapp/customer-manager/measuringRoom/surveyInvitation'),
        meta: {
          title: '勘测邀请'
        }
      }
    ]
  }
]
export default radTwoRouter
